import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M18 9v4H6V9H4v6h16V9z" />, 'SpaceBar');
